import React from 'react'
import { Trans } from '@lingui/macro'

import classes from './Title.module.scss'

export const Title = () => {
  return (
    <h1 className={classes.Title}>
      <Trans>429 | Too many requests</Trans>
    </h1>
  )
}
